module.exports = __webpack_public_path__ + "static/media/CTLI_13-444w.adc15b02.jpg";